module.exports = __webpack_public_path__ + "img/36944-050.29532ef6.jpg";